(function ($) {
	const twentytwenty = () => {
		$(".twentytwenty-container[data-orientation!='vertical']").each(function () {
			const $container = $(this);
			if ($container.data('twentytwenty')) {
				return;
			}

			$container.twentytwenty({
				default_offset_pct: 0.5,
				before_label: this.dataset.beforeLabel || '',
				after_label: this.dataset.afterLabel || '',
			});
		});
	};

	twentytwenty();
	document.addEventListener('shopify:section:load', twentytwenty);
})(jQuery);
